document.addEventListener('DOMContentLoaded', function() {
    const atcBtns = document.querySelectorAll('.js-add-to-cart');
  
    atcBtns.forEach(function(btn) {
      btn.addEventListener('click', function(event) {
        event.preventDefault();
        this.setAttribute('disabled', 'true');
        const variantId = this.getAttribute('data-id');
        const sellingPlanId = this.getAttribute('data-selling-plan-id');
        const quantity = parseInt(this.getAttribute('data-quantity')) || 1;
        const discountCode = this.getAttribute('data-discount-code');
  
        this.querySelector('.loader')?.classList.add('active');
  
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.json())
        .then(() => {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: variantId,
                quantity: quantity,
                ...(sellingPlanId && { selling_plan: sellingPlanId })
              }]
            })
          });
        })
        .then(response => response.json())
        .then(() => {
            let checkoutUrl = '/checkout';
            if (discountCode) {
              const formattedDiscount = discountCode
                  .split(' ')
                  .filter(code => code.trim() !== '')
                  .join(',');
              checkoutUrl += `?discount=${encodeURIComponent(formattedDiscount)}`;
            }
            window.location.href = checkoutUrl;
        })
        .catch(error => {
          console.error('Error processing cart:', error);
          this.querySelector('.loader')?.classList.remove('active');
        });
      });
    });
  });